/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import './threat-intelligence-widget.component.less';
import { CPortalPageStore } from '../cportal-page.store';
import * as l10n from './threat-intelligence-widget.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Widget to display Threat Intelligence within the cloud service page.
 * @author Deepak Chaudhary
 */
@Component({
    selector: 'threat-intelligence-widget',
    templateUrl: './threat-intelligence-widget.component.html',
})
export class ThreatIntelligenceWidgetComponent {
    public readonly pulseWafManagementStatus$ = this.cPortalPageStore.pulseWafManagementStatus$;
    public readonly wafSignaturesNotificationsStatus$ = this.cPortalPageStore.wafSignaturesNotificationsStatus$;
    public readonly autoDownloadWafSignaturesStatus$ = this.cPortalPageStore.autoDownloadWafSignaturesStatus$;
    public readonly appSignatureSyncStatus$ = this.cPortalPageStore.appSignatureSyncStatus$;
    public readonly ipReputationStatus$ = this.cPortalPageStore.ipReputationStatus$;
    public readonly userAgentDbSyncStatus$ = this.cPortalPageStore.userAgentDbSyncStatus$;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly cPortalPageStore: CPortalPageStore,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
